<template>
  <nuxt-link
    :class="['smallBlogTile']"
    :to="localePath({ name: 'blog-slug', params: { slug: item.key } })"
  >
    <div class="smallBlogTile__image">
      <new-image-box
        :alt="item.title"
        :src="item.image"
        :width="330"
        :height="284"
        fit
        image-params="w_330,h_284,crop"
      />
      <div class="smallBlogTile__content">
        <div class="smallBlogTile__categories" v-if="item.categories && item.categories.length">
          <div
            :key="category.id"
            class="smallBlogTile__category"
            v-for="category in item.categories"
          >
            {{ category.name }}
          </div>
        </div>
        <h3 class="smallBlogTile__title">
          {{ item.title }}
        </h3>
      </div>
    </div>
  </nuxt-link>
</template>

<script>
import NewImageBox from '@/components/NewImageBox';

export default {
  name: 'SmallBlogTile',
  components: {
    NewImageBox,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    swiperLazyLoad: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.smallBlogTile {
  $root: &;
  position: relative;
  display: block;

  &__image {
    position: relative;
    overflow: hidden;

    img {
      transition: transform $tr, opacity $tr;
    }

    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      height: 100%;
      width: 100%;
      background: rgba($cBlack, 0.3);
      background: linear-gradient(0deg, rgba(23, 25, 51, 0.7) 0%, rgba(255, 255, 255, 0) 100%);
    }
  }

  &__categories {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -0.5rem 1rem;
  }

  &__category {
    font-size: 1.1rem;
    line-height: 1.4rem;
    font-weight: 900;
    letter-spacing: 0.01em;
    text-transform: uppercase;
    padding: 0 0.5rem;
    color: $cWhite;
  }

  &__content {
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 2rem;
    z-index: 2;
  }

  &__title {
    font-weight: 600;
    font-size: 1.8rem;
    line-height: 2.3rem;
    color: $cWhite;
    transition: color $tr;

    @include rwd('tablet') {
      font-size: 1.6rem;
      line-height: 2.1rem;
    }
  }

  &:hover {
    #{$root}__image {
      img {
        transform: scale(1.05);
      }
    }
  }
}
</style>
